'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$() {
}
export { $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ as $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ };
$p = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$() {
}
export { $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ as $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ };
$h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$.prototype = $p;
$p.eu = (function() {
  return 0;
});
var $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$, "dev.cheleb.scalamigen.Defaultable$given_Defaultable_Int$", ({
  iT: 1,
  aR: 1
}));
export { $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ as $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ };
var $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$;
function $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$() {
  if ((!$n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$)) {
    $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ = new $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$();
  }
  return $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$;
}
export { $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ as $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$ };
